<div [loading]="loadingEasements">
  <ng-container *ngIf="data.customData.notStartedParcelIds.length > 0 && !loadingEasements && data?.list?.list">
    <span>VB k řešení</span>
    <ul>
      <ng-container *ngFor="let dataEasement of this.notStartedParcels">
        <li>
          <a *ngIf="dataEasement.easement.parcel" uiSref="symap.project.parcels.detail" [uiParams]="{id: dataEasement.easement.parcel.id}">{{dataEasement.easement.parcel|parcelnumber}}</a>
          <ng-container *ngIf="dataEasement.easement.geometricPlan"> ({{dataEasement.easement.geometricPlan.fiktivni ? 'ZE' : 'GP'}})</ng-container>
          <gmt-construction-object-list *ngIf="dataEasement.easement.constructionObjects.length" [constructionObjects]="dataEasement.easement.constructionObjects"></gmt-construction-object-list>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <ng-container *ngIf="data.customData.inProgressParcelIds.length > 0 && !loadingEasements && data?.list?.list">
    <span>Řešená VB</span>
    <ul>
      <ng-container *ngFor="let dataEasement of this.inProgressParcels">
        <li>
          <a *ngIf="dataEasement.easement.parcel" uiSref="symap.project.parcels.detail" [uiParams]="{id: dataEasement.easement.parcel.id}">{{dataEasement.easement.parcel|parcelnumber}}</a>
          <ng-container *ngIf="dataEasement.easement.geometricPlan"> ({{dataEasement.easement.geometricPlan.fiktivni ? 'ZE' : 'GP'}})</ng-container>
          <gmt-construction-object-list *ngIf="dataEasement.easement.constructionObjects.length" [constructionObjects]="dataEasement.easement.constructionObjects"></gmt-construction-object-list>
          <span *ngIf="dataEasement.titleId && data.customData.titleId && data.customData.titleId != dataEasement.titleId" title="Řešeno na bývalém LV" class="tag tag--danger tag--small is-uppercase ml-5">LV</span>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <ng-container *ngIf="data.customData.doneParcelIds.length > 0 && !loadingEasements && data?.list?.list">
    <span>Vyřešená VB</span>
    <ul>
      <ng-container *ngFor="let dataEasement of this.doneParcels">
        <li>
          <a *ngIf="dataEasement.easement.parcel" uiSref="symap.project.parcels.detail" [uiParams]="{id: dataEasement.easement.parcel.id}">{{dataEasement.easement.parcel|parcelnumber}}</a>
          <ng-container *ngIf="dataEasement.easement.geometricPlan"> ({{dataEasement.easement.geometricPlan.fiktivni ? 'ZE' : 'GP'}})</ng-container>
          <gmt-construction-object-list *ngIf="dataEasement.easement.constructionObjects.length" [constructionObjects]="dataEasement.easement.constructionObjects"></gmt-construction-object-list>
          <span *ngIf="dataEasement.titleId && data.customData.titleId && data.customData.titleId != dataEasement.titleId" title="Řešeno na bývalém LV" class="tag tag--danger tag--small is-uppercase ml-5">LV</span>
        </li>
      </ng-container>
    </ul>
  </ng-container>
</div>

